import { ChangeDetectionStrategy, Component, Input, OnInit, QueryList, ViewChild } from '@angular/core';
import type { ChartType, ChartOptions, ChartDataset } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
//import { SingleDataSet, Label } from 'ng2-charts';
//import 'chartjs-plugin-labels';
//import  'chartjs-plugin-datalabels';
import { jsPDF } from "jspdf";
//import 'chartjs-plugin-colorschemes';
import html2canvas from 'html2canvas';
import { GlobalsessionhandlerService } from 'src/app/shared/services/globalsessionhandler.service';
import { Constants } from '../../constants';
import { BaseHttpService } from '../../services/basehttp.service';
import { NotificationService } from '../../services/notifications.service';
import { Router } from '@angular/router';
import { ChartDataSet, ChartDrillDownData } from '../../models/drilldownchart.model';
import { faDrawPolygon } from '@fortawesome/free-solid-svg-icons';
import { UserTypeId } from '../../models/userType.model';

@Component({
  selector: 'app-drilldownchart',
  templateUrl: './drilldownchart.component.html',
  styleUrls: ['./drilldownchart.component.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush
  standalone: false
})
export class DrilldownchartComponent implements OnInit {
  @Input() drillDownChartData?: ChartDrillDownData ;
  @Input() chartIndex:number=0 ;
  @Input() chartName?:string="";
  @Input() roleType:UserTypeId;
  //title:string;
  //$this:any;
  @ViewChild(BaseChartDirective,{static:true})// charts: QueryList<BaseChartDirective>;
   charts: QueryList<BaseChartDirective>
   constant: Constants = new Constants();
   seqNum:number[]=[];
   currentSeqNum=1;
   ChartTitle:string[]=[];
   SequentialDataSet:any[]=[];
   IschartVisible:boolean[]=[];

   colorSetForBarChart=   ['#A7CFEC','#d8e2e8', '#5499C7', '#c6dbef', '#9ecae1', '#6baed6','#f7fbff',
      '#4292c6', '#2171b5', '#08519c', '#08306b',
      '#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636'];
  //Pie chart configuration #5499C7  BFC9CA
    public pieChartColors: Array < any > = [{
 
     backgroundColor:
      ['#A7CFEC','#d8e2e8', '#D5D8DC', '#c6dbef', '#9ecae1', '#6baed6','#f7fbff',
       '#4292c6', '#2171b5', '#08519c', '#08306b',
       '#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636'],
     hoverBackgroundColor:
     ['#A7CFEC','#d8e2e8', '#D5D8DC', '#c6dbef', '#9ecae1', '#6baed6','#f7fbff',
       '#4292c6', '#2171b5', '#08519c', '#08306b',
       '#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59',
        '#014636'],
  
    }];
public pieChartLabels:any[] =[];
public pieChartData:any[] =[];
public pieChartType:ChartType = 'pie';
public pieChartLegend = true;
public pieChartPlugins =[];
public pieChartOptions: ChartOptions ;
  
// bar chart configuration 
   barChartData:any[] =[];
   barChartLabel:any[]=[];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins=[];
  public barChartOptions: ChartOptions ;
  //commented splitBarChartOptions, pieChartOptions, barChartOptions
//   public splitBarChartOptions: ChartOptions =
//   {
//     responsive: true, 
//     legend:{position:"top",fullWidth:false, 
//     labels:{
//       fontColor:"black", fontSize:16,boxWidth:30
//       }
//     },
//    layout: {
//      padding: {
//          left: 0,right: 0,top: 10,bottom: 10
//      }
//  },
//    plugins: {      
//        labels: [
//                   {
//           render: 'value'
//          }],
     
//      datalabels: {
//       display: function(context) {
//         const dataPoint = context.dataset.data[context.dataIndex];
    
//         if (typeof dataPoint === 'number') {
//             return dataPoint > 0;
//         }
    
//         return false; // Default to false if dataPoint is not a number
//     },    
//         color: 'black',
//         align: 'right',
//         offset:8,         
//         font: {
//            //weight: 'bold'
//            size:13
//          }
//      }
//  },
//    tooltips:{
//    },  
//    scales: {
//      x: {
//       beginAtZero: true,
//        ticks:
//        {           
        
//         stepSize:5, //fontSize: 13,fontColor:'black',  
//         font:{
//           size:13,
          
//          },
//          color:'black',    
//         display:true

//          },
//         //  gridLines: {
//         //      display:true
//         //  }
//         grid: {
//           display:true
//       }
//      },
//      y: {          
//          ticks:
//          {
//            stepSize:5, font:{
//             size:12,
            
//            },
//            color:'black'
//            //fontSize: 12,fontColor:'black'//,fontStyle:"bold" 
//          },
//          grid: {
//              display:false
//          }   
//      }
//  }

//   };
queindex: any;
splitBarChartOptions: any;
  

  constructor(private baseHttpService: BaseHttpService,private sessionhandler:GlobalsessionhandlerService
    ,private router: Router, private notificationService: NotificationService)
    { 
  //monkeyPatchChartJsTooltip();
  //monkeyPatchChartJsLegend();
  const that = this; //Creating the helper constant that can be used in callbacks to refer to the AppComponent's context

// this.pieChartOptions= {
//   responsive: true,
//   onClick:function(e,items) {
    
//     if(items.length>0)
//     {
//       //highlight pie-chart secction only under organization view as other charts as common data
//       if(that.chartIndex==0)
//       {
//         this.data.datasets[0].borderColor=[];
//         this.data.datasets[0].borderWidth=[];
//         this.data.datasets[0].backgroundColor.forEach(element => {
//           this.data.datasets[0].borderColor.push("White");
//           this.data.datasets[0].borderWidth.push(0);
//         });
//         this.data.datasets[0].borderColor[this.active[0]._index]="#0B5D94";
//         this.data.datasets[0].borderWidth[this.active[0]._index]=3;
//         this.update();
//       }
//       let currentChartDataSet= items[0]['_chart'].config.data;
//       let idx = items[0]['_index'];
//     that.DrawNextChart(currentChartDataSet,idx);
//     }
//   },
 
//   elements: {
//     arc: {
//         borderWidth:1
//     }
// },
// legend:{position:"right",fullWidth:false, 
// labels:{
//   fontColor:"black", fontSize:16,boxWidth:30
//   }
// },
// animation: {
//   duration: 0
// },    maintainAspectRatio: true,
//   plugins: {
    
//       datalabels: 
//       {
//         display:false,
//         color:"black",
//         font:{
//           weight:"bold"
//         }
//           },

//     labels: [        
//       {
//         render: 'value',
//         fontColor: 'black' , 
//         fontSize: 16

//       }]
//   },
//   tooltips:{      
//   },

// };

//   this.barChartOptions= {
//   responsive: true,  
//   legend:{position:"top",fullWidth:false, 
// labels:{
//   fontColor:"black", fontSize:16,boxWidth:30
//   }
// },
//   onClick:function(e,items)
//   {
    
// if(items.length>0)
// {
//    let chartId=this.canvas.id.split("-")[1];
//    let activePoint = this.getElementAtEvent(e)[0];
//    let data = activePoint._chart.data;
//    let datasetIndex = activePoint._datasetIndex;
//    let label = data.datasets[datasetIndex].label;
//    let value = data.datasets[datasetIndex].data[activePoint._index];

//       this.data.datasets.forEach(element => {
//         element.borderColor=[];
//         element.borderWidth=[];

//         element.data.forEach(element1 => {
//           element.borderWidth.push(0);
//           element.borderColor.push("White");
//         });
//       });

//       if(that.chartIndex==0 && chartId=="2")
//       {
//         this.data.datasets[datasetIndex].borderColor[activePoint._index]="#0B5D94";
//         this.data.datasets[datasetIndex].borderWidth[activePoint._index]=3;
//       }
//       else
//       {
//         this.data.datasets.forEach(element1 => {
      
//           element1.borderColor[activePoint._index]="#0B5D94";
//           element1.borderWidth[activePoint._index]=3;
        
//       });
//       }
    
     
//    this.update();

//    that.DrawNextStackedBarChart(chartId,data,datasetIndex,label,value,activePoint._index);
// }  
//   },

//    layout: {
//      padding: {
//          left: 0,right: 0,top: 10,bottom: 10
//      }
//  },
//    plugins: {      
//        labels: [
//                   {
//           render: 'value'
//          }],
     
//      datalabels: {
//       display: function(context) {
//         const dataPoint = context.dataset.data[context.dataIndex];
    
//         if (typeof dataPoint === 'number') {
//             return dataPoint > 0;
//         }
    
//         return false; // Default to false if dataPoint is not a number
//     }
//     ,
//         color: 'black',
//         align: 'right',
//         offset:8,         
//         font: {
//            //weight: 'bold'
//            size:13
//          },        
//           ////  formatter: (value, ctx) => {
           
//           ////               },
           
       
//      }
//  },
//    tooltips:{
//    },  
//    scales: {
//      x: {
//        stacked: true,
//        beginAtZero: true,
//        ticks:
//        {           
//          stepSize:5, //fontSize: 13,fontColor:'black',
//          font:{
//           size:13,
          
//          },
//          color:'black',

//          display:true

//          },
//          grid: {
//              display:true
//          }
//      },
//      y: {   
//        stacked: true,     
//          ticks:
//          {
//            stepSize:5, //fontSize: 12,fontColor:'black'//,fontStyle:"bold" 
//            font:{
//             size:12,
            
//            },
//            color:'black'
//          },
//          grid: {
//              display:false
//          }   
//      }
//  }
//  };
  
    }
  

  ngOnInit() {
 
    let dataForPieChart:any[] =[];
    this.drillDownChartData[this.chartIndex].dataset.find(x=>x.seqNumber==1).dataset.map(({ data }) => data).forEach(function(y)
    {
      dataForPieChart.push(y[0]);
    })
    this.pieChartData=dataForPieChart;
    this.pieChartLabels=this.drillDownChartData[this.chartIndex].dataset.find(x=>x.seqNumber==1).dataset.map(({ label }) => label);
 
this.ChartTitle.push(this.drillDownChartData[this.chartIndex].sequentialChartType[0].chartTitle);
this.SequentialDataSet=[];
this.IschartVisible=[];

this.SequentialDataSet.push("0");
  if(this.roleType==UserTypeId["Organization Admin"] && (this.chartIndex!=2) )
  {
     

     this.IschartVisible.push(false);
     this.DrawNextChart(this.drillDownChartData[this.chartIndex].dataset,0);
  }
  else if(this.roleType==UserTypeId["Group Admin"])
  {

    this.IschartVisible.push(false);
    this.DrawNextChart(this.drillDownChartData[this.chartIndex].dataset,0);
  }
  else 
  {
    this.IschartVisible.push(true);
  }

}

DrawNextChart(currentChartDataSet,idx)
{

      
        // let value = currentChartDataSet.datasets[0].data[idx];
        // let color = currentChartDataSet.datasets[0].backgroundColor[idx];
         this.currentSeqNum=2;
         this.ChartTitle.push(this.drillDownChartData[this.chartIndex].sequentialChartType[this.currentSeqNum-1].chartTitle);

         this.seqNum=[];
         this.seqNum.push(this.currentSeqNum);
         this.barChartData=[];
         this.barChartLabel=[];
         
       let nextChart=null;
       if(this.chartIndex>0)
       {
        nextChart= this.drillDownChartData[this.chartIndex].dataset.filter(x=>x.seqNumber==this.currentSeqNum) ;

       }
       else
       {

      let label ="";
      if(this.roleType==UserTypeId["Organization Admin"])
      {
        label= currentChartDataSet[0].dataset[0].label

      } 
      else
      {
        label=currentChartDataSet.labels[idx];
      }
       nextChart= this.drillDownChartData[this.chartIndex].dataset.filter(x=>x.seqNumber==this.currentSeqNum && x.parentVal==label ) ;
       
       }
       let distinctNextChart = nextChart.filter((thing, i, arr) => {
        return arr.indexOf(arr.find(t => t.id===thing.id)) === i;
      });
     if(distinctNextChart.length<=0)
     {
       this.barChartData.push([]);
       this.barChartLabel.push("NA");
       return;
     } 
      let distinctThings = distinctNextChart[0].dataset.filter((thing, i, arr) => {
        return arr.indexOf(arr.find(t => t.label===thing.label)) === i;
      });
      let brDtset: ChartDataset[]=[];
      let countLegeds=0;
      distinctThings.forEach(element => {
     
       brDtset.push({data:element.data,label:element.label,
   
    backgroundColor:this.colorSetForBarChart[countLegeds],
    hoverBackgroundColor:this.colorSetForBarChart[countLegeds]
   
      
      });
      countLegeds=countLegeds+1;
          
      });
      this.barChartData.push(brDtset);
    

       this.barChartLabel.push(distinctNextChart[0].chartLabels);
       if(this.SequentialDataSet.length==this.currentSeqNum)
       {
        this.SequentialDataSet.splice(this.currentSeqNum-1);
       }
       this.SequentialDataSet.push(nextChart);

       if(this.roleType==UserTypeId["Group Admin"])
       {
       
       this.IschartVisible.splice(this.currentSeqNum-1);
       this.IschartVisible.push(false);
       let createData={labels:this.drillDownChartData[this.chartIndex].dataset.filter(x=>x.seqNumber==this.currentSeqNum)[0].chartLabels};
       this.DrawNextStackedBarChart(this.currentSeqNum,createData,0,null,0,0)
       }
       else{
        this.IschartVisible.push(true);
        this.scrollOnChart("chartName-"+this.currentSeqNum);

       }

      }
DrawNextStackedBarChart(chartId,data,datasetindex,label,value,barindex)
{
  
  if(this.chartIndex==2 && (Number(chartId)+1)==4)
  {
    return;
  }
  this.currentSeqNum=Number(chartId)+1;
  if(this.seqNum.length>=this.currentSeqNum-1)
  {
    this.seqNum.splice(this.currentSeqNum-2);
  }
  if(this.barChartData.length>=this.currentSeqNum-1)
  {
    this.barChartData.splice(this.currentSeqNum-2);
    this.barChartLabel.splice(this.currentSeqNum-2);
  }
  this.seqNum.push(this.currentSeqNum);



  let nextChart =null;
  if(this.chartIndex==0)
  {
    if(this.currentSeqNum<4)
    {
      nextChart= this.drillDownChartData[this.chartIndex].dataset.filter(x=>x.seqNumber==this.currentSeqNum && x.parentVal==label && x.parentId== this.SequentialDataSet[this.currentSeqNum-2][0].dataId[barindex] ) ;
    }
    else
    {
      nextChart= this.drillDownChartData[this.chartIndex].dataset.filter(x=>x.seqNumber==this.currentSeqNum && x.parentId== this.SequentialDataSet[this.currentSeqNum-2][0].dataId[barindex] ) ;

    } 
  }
  else
  {
    nextChart= this.drillDownChartData[this.chartIndex].dataset.filter(x=>x.seqNumber==this.currentSeqNum && x.parentId== this.SequentialDataSet[this.currentSeqNum-2][0].dataId[barindex] ) ;

  }
  this.ChartTitle.splice(this.currentSeqNum-1);
  // // if(this.currentSeqNum==4)
  // // {
  // //   //this.ChartTitle.push(data.labels[barindex]+" - Group User Details");
  // //   this.ChartTitle.push(data.labels[barindex]+" - " +this.drillDownChartData[this.chartIndex].sequentialChartType[this.currentSeqNum-1].chartTitle);

  // // }
  // // else
  // // {
    this.ChartTitle.push(data.labels[barindex]+" - " +this.drillDownChartData[this.chartIndex].sequentialChartType[this.currentSeqNum-1].chartTitle);
  ////this.ChartTitle.push(data.labels[barindex]+" - Group Access Details");
  ////}
  if(nextChart.length<=0)
  {
    this.barChartData.push([]);
    this.barChartLabel.push("NA");
    return;
  } 

   let distinctThings = nextChart[0].dataset.filter((thing, i, arr) => {
     return arr.indexOf(arr.find(t => t.label===thing.label)) === i;
   });
   let brDtset: ChartDataset[]=[];
   let countLegeds=0;
   distinctThings.forEach(element => {
  
    brDtset.push({data:element.data,label:element.label,
      backgroundColor:this.colorSetForBarChart[countLegeds],
      hoverBackgroundColor:this.colorSetForBarChart[countLegeds]    
    });
    countLegeds=countLegeds+1;
    
       
   });
   this.barChartData.push(brDtset);
 

    this.barChartLabel.push(nextChart[0].chartLabels);
       if(this.SequentialDataSet.length>=this.currentSeqNum)
       {
        this.SequentialDataSet.splice(this.currentSeqNum-1);
       }
       this.SequentialDataSet.push(nextChart);
  this.IschartVisible.push(true);
  this.scrollOnChart("chartName-"+this.currentSeqNum);


}

scrollOnChart(chartId)
{
  
  setTimeout(function() { 
    document.getElementById(chartId).scrollIntoView() 
  }, 10);
}

}
